// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  border-radius: 18px;
  box-shadow: 0px 12px 8px rgba(0, 0, 0, 0.3019607843);
  max-width: -webkit-max-content;
  max-width: -moz-max-content;
  max-width: max-content;
  height: 100%;
}
.wrapper .text-area {
  text-align: center;
}
.wrapper .text-area .title {
  font-weight: bold;
  padding-top: 0.75rem;
}
.wrapper .text-area .content {
  padding-top: 0.5rem;
}
.wrapper .text-area .contact {
  padding-top: 1rem;
  padding-bottom: 1rem;
  display: flex;
  justify-content: center;
}
.wrapper .text-area .contact img {
  margin-right: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/home/banner-card/banner-card.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,oDAAA;EACA,8BAAA;EAAA,2BAAA;EAAA,sBAAA;EACA,YAAA;AACF;AAAE;EACE,kBAAA;AAEJ;AADI;EACE,iBAAA;EACA,oBAAA;AAGN;AADI;EACE,mBAAA;AAGN;AADI;EACE,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;AAGN;AAFM;EACE,kBAAA;AAIR","sourcesContent":[".wrapper {\n  border-radius: 18px;\n  box-shadow: 0px 12px 8px #0000004d;\n  max-width: max-content;\n  height: 100%;\n  .text-area {\n    text-align: center;\n    .title {\n      font-weight: bold;\n      padding-top: 0.75rem;\n    }\n    .content {\n      padding-top: 0.5rem;\n    }\n    .contact {\n      padding-top: 1rem;\n      padding-bottom: 1rem;\n      display: flex;\n      justify-content: center;\n      img {\n        margin-right: 1rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
